import '../../../app/globals.css'
import '../../index.css'

const SideBar = ({children}:{children:React.ReactNode}) => {
  return (
    <aside 
    id="default-sidebar" 
    className="fixed top-0 left-0 z-40 h-screen transition-transform -translate-x-full sm:translate-x-0 rounded-tr-lg rounded-br-lg bg-blue100" aria-label="Sidebar">
    <div className="flex flex-col h-full p-2 pt-4 overflow-y-auto items-center">
        {children}
    </div>
  </aside>
  )
}

export default SideBar